import { Order } from 'entities/order'
import { ViewModel } from 'view_models/view_model'

export class StandardUrineViewModel extends ViewModel<Order> {
    public date = () => {
        return this.toDateText(this.object.date)
    }
}
